import type { FileRecord } from "@cohesive/api-client";
import { pickFileRecordMediaURL } from "@cohesive/ui-components";
import { Music } from "lucide-react";
import { formatFileSize, getFileRecordName } from "../contentType";
import { useFileRecordVersionPreview } from "../versioning/FileRecordVersioningContext";

export function AudioContent({ record }: { record: FileRecord }) {
  const fileName = getFileRecordName(record);
  const { previewMediaUrl } = useFileRecordVersionPreview();
  const mediaUrl =
    previewMediaUrl ??
    pickFileRecordMediaURL(record, "full") ??
    pickFileRecordMediaURL(record, "thumbnail");

  if (!mediaUrl) {
    return (
      <div className="flex items-center justify-center h-full text-sm text-muted-foreground">
        Audio not available.
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center h-full gap-6 p-8 bg-muted/10">
      {/* Purely decorative — audio players ship their own transport UI.
          The icon just anchors the otherwise empty pane visually. */}
      <div className="h-20 w-20 rounded-full bg-muted/40 flex items-center justify-center">
        <Music className="h-10 w-10 text-muted-foreground" strokeWidth={1.5} />
      </div>
      <div className="text-center max-w-md">
        <p className="font-medium text-foreground truncate">{fileName}</p>
        {record.size > 0 && (
          <p className="text-xs text-muted-foreground mt-1">
            {formatFileSize(record.size)}
          </p>
        )}
      </div>
      <audio
        key={mediaUrl}
        src={mediaUrl}
        controls
        controlsList="nodownload"
        preload="metadata"
        className="w-full max-w-md"
      />
    </div>
  );
}
